<script setup lang="ts">
defineOptions({
	name: 'WhatAreCookiesSection',
})

const { t: $t } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:help-outline"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('What are cookies?') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						'Cookies are small text files that the web pages you visit send to the browser you are using, allowing for the collection and storage of information. They serve various purposes, such as identifying you as a user, gathering information about your browsing habits, or personalising the content presented to you. Cookies can be classified according to their origin, purpose, and duration',
					)
				}}.
			</p>
		</div>
	</section>
</template>
